type DashboardHeaderProps = {
  givenName?: string;
};

export default function DashboardHeader({
  givenName,
}: DashboardHeaderProps) {
  const displayName = givenName?.trim() || "there";

  return (
    <header className="flex flex-col gap-4 border-b border-[#232836] pb-5 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="text-2xl font-semibold text-[#D0D0D0] sm:text-3xl">
          Welcome back, {displayName} <span aria-hidden="true">👋</span>
        </h1>
        <p className="mt-2 text-sm text-[#9CA3AF]">
          Your SolarCloud at a glance
        </p>
      </div>
    </header>
  );
}
